import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.lootbox.box,
    props.lootbox.buttons.open,
    (box, button) => {
        return {
            box,
            button
        }
    }
)